/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "@/shadcnComponents/ui/button";
import axios from "axios";
import { useEffect, useState } from "react";
import { BiSync } from "react-icons/bi";
import { useNavigate } from "react-router-dom";
import {
  ExtensionCheckDialog,
  InstallExtensionDialogContainer,
  SyncLinkedinWithExt,
} from "./SyncLinkedinWithExt";
import { useAuth } from "@/Providers/Auth";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/shadcnComponents/ui/table";
import { ArrowRight, EyeIcon, InfoIcon } from "lucide-react";
import { useInfluencer } from "@/Providers/Influencer";

import { useToast } from "@/shadcnComponents/ui/use-toast";
import { HiLightBulb } from "react-icons/hi";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "../../../shadcnComponents/ui/tooltip";
// import { RoundedPillTag, TableBodyCell } from "./Components";
import { BsLinkedin } from "react-icons/bs";
import { formatFollowersCount } from "../../../Helpers/format-helper";
import { PostPerformanceTable } from "../../Dashboard/Influencer/PostPerformance/Components/organisms";

const host = import.meta.env.VITE_BACKEND_SERVER_URL;

export const ExtPreviewData = () => {
  const authState = useAuth();
  const influencerState = useInfluencer();
  const navigate = useNavigate();
  const [extData, setExtData] = useState(null);
  const [openExtInstall, setOpenExtInstall] = useState(false);
  const { toast } = useToast();
  const [loading, setLoading] = useState(true);

  // const [sortColumn, setSortColumn] = useState(null); // Column being sorted
  // const [sortOrder, setSortOrder] = useState("asc"); // Sort order (asc or desc)

  useEffect(() => {
    const getUpdatedData = async () => {
      try {
        const res = await axios.get(`${host}/ext/linkedin/me`, {
          headers: { jwtToken: localStorage.getItem("jwtToken") },
        });
        if (res?.data?.success) {
          setExtData(res?.data?.data);

          if (authState?.loggedUser && !authState?.loggedUser?.linkedinLink) {
            // upload profile image
            const profile = res?.data?.data?.profile?.profile_image;

            // update influencer profile data
            await influencerState?.updatePersonalInfo({
              tagline: res?.data?.data?.profile?.tagline,
              linkedinLink: res?.data?.data?.profile?.profile_url,
              gender: res?.data?.data?.profile?.gender,
              followers: {
                linkedin: res?.data?.data?.profile?.followers,
              },
              profile,
            });

            // update toplinks
            const updatedTopLinksData =
              res?.data?.data?.profile?.custom_button?.map((i) => {
                return {
                  link: i?.link,
                  linkText: i?.link_text,
                };
              });

            influencerState?.updateTopLinksInfo(updatedTopLinksData);
          }
        }
      } catch (error) {
        console.log("Error fetching data", error);
      } finally {
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      }
    };
    getUpdatedData();
  }, [authState.loggedUser]);

  // Function to handle sorting
  // const handleSort = (column) => {
  //   const order = sortColumn === column && sortOrder === "asc" ? "desc" : "asc";
  //   setSortOrder(order);
  //   setSortColumn(column);

  //   // Clone and sort data
  //   const sortedPosts = [...extData.posts].sort((a, b) => {
  //     let valueA = parseInt(a[column]?.replace(/[,]/g, "")) || 0;
  //     let valueB = parseInt(b[column]?.replace(/[,]/g, "")) || 0;

  //     // Calculate engagement rate for engagement sorting
  //     if (column === "engagement") {
  //       const engagementRateA =
  //         ((parseInt(a?.likes?.replace(/[,]/g, "")) +
  //           parseInt(a?.comments?.replace(/[,]/g, "")) +
  //           parseInt(a?.reposts?.replace(/[,]/g, ""))) /
  //           parseInt(extData?.profile?.followers?.replace(/[,]/g, ""))) *
  //         100;
  //       const engagementRateB =
  //         ((parseInt(b?.likes?.replace(/[,]/g, "")) +
  //           parseInt(b?.comments?.replace(/[,]/g, "")) +
  //           parseInt(b?.reposts?.replace(/[,]/g, ""))) /
  //           parseInt(extData?.profile?.followers?.replace(/[,]/g, ""))) *
  //         100;
  //       valueA = engagementRateA;
  //       valueB = engagementRateB;
  //     }

  //     return order === "asc" ? valueA - valueB : valueB - valueA;
  //   });

  //   // Update the sorted data
  //   setExtData((prev) => ({ ...prev, posts: sortedPosts }));
  // };

  return (
    <>
      {openExtInstall && (
        <ExtensionCheckDialog
          open={openExtInstall}
          onOpenChange={setOpenExtInstall}
          content={
            <InstallExtensionDialogContainer
              reSync={true}
              redirectUrl={`${window.location.origin}/influencer/plugin/callback`}
              closeCurrentWindow={true}
              open={openExtInstall}
            />
          }
        />
      )}
      {loading && <LoadingSkeleton />}
      {!loading && extData?.profile?.updatedAt && (
        <div className="bg-[#171717] grid min-h-screen w-full text-white/80 py-6">
          <div className="w-full px-[4%] md:px-[10%] overflow-hidden h-full">
            <div className="w-full flex justify-center mb-6">
              <div className="md:w-1/4 rounded-full bg-[#004222] text-[#0ACB6E] px-4 py-1.5 flex items-center gap-2 justify-center">
                <EyeIcon size={20} className="shrink-0" />
                <span className="font-[Inter] text-xs not-italic font-medium leading-[normal] text-nowrap">
                  Only Visible to You
                </span>
              </div>
            </div>
            {/* Profile */}
            <div className="flex flex-col md:flex-row justify-between border border-[#262626] rounded-[8px]">
              <div className="flex flex-col md:flex-row gap-3 items-center py-10 md:py-4 px-4">
                <img
                  src={
                    extData?.profile?.profile_image ||
                    authState?.loggedUser?.profile
                  }
                  alt=""
                  className="size-16 rounded-[10px]"
                />
                <div className="text-center md:text-start">
                  <h3 className="font-[Inter] text-sm not-italic font-semibold leading-[20px]">
                    {extData?.profile?.name}
                  </h3>
                  <p className="text-[#919191] font-[Inter] text-xs not-italic font-normal leading-[20px] md:line-clamp-1 md:max-w-[500px]">
                    {extData?.profile?.tagline}
                  </p>
                  <div className="flex gap-1 justify-center items-center md:justify-start">
                    <span className="text-[#919191]">
                      <BsLinkedin size={16} />
                    </span>
                    <span className="text-[#919191] font-[Inter] text-xs not-italic font-semibold leading-[20px]">
                      {formatFollowersCount(extData?.profile?.followers) || "-"}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex flex-row md:justify-end  items-center justify-center p-4">
                <div className="flex md:flex-row gap-2 md:items-start  items-center">
                  <div className="flex flex-col justify-end gap-2 ">
                    <Button
                      variant="destructive"
                      className="p-2 hover:bg-red-800 rounded-md border border-red-800 text-xs md:text-sm"
                      onClick={() => {
                        if (window.innerWidth <= 768) {
                          // Mobile screen, show a toast message
                          toast({
                            title: "Please switch to a desktop to sync",
                            variant: "destructive",
                          });
                        } else {
                          // Desktop screen, execute the function
                          setOpenExtInstall(true);
                        }
                      }}
                    >
                      <span className="text-white font-inter">Sync again</span>
                      <BiSync size={20} title="sync" className="" />{" "}
                    </Button>
                    <div className="hidden md:flex  flex-col text-end">
                      <span
                        className="text-green-500 text-xs font-inter cursor-default"
                        title={new Date(
                          extData?.profile?.updatedAt
                        ).toLocaleString()}
                      >
                        Updated on:{" "}
                        {new Date(extData?.profile?.updatedAt).toDateString()}
                      </span>
                    </div>
                  </div>
                  <Button
                    variant="secondary"
                    className="text-xs md:text-sm "
                    onClick={() => navigate(`/influencer/edit`)}
                  >
                    Save & View Media Kit
                    <ArrowRight size={20} className="ml-2" />
                  </Button>
                </div>
              </div>
            </div>

            {/* Posts Table */}
            <div className="">
              <div className="py-6 flex flex-col gap-3 ">
                <div className="mt-6">
                  <span className="text-[#A6A6A6] font-[Inter] text-sm not-italic font-medium leading-[24px] flex gap-1 items-center">
                    <span className="w-fit">
                      <HiLightBulb
                        size={20}
                        color="#F1F1F1"
                        className="shrink-0"
                      />
                    </span>
                    <span className="w-fit">
                      Here are your LinkedIn stats at a glance to help you
                      create content, better.
                      <span className="text-white">
                        {" "}
                        Sync again, if something is incorrect.
                      </span>
                    </span>
                    <span className="w-fit">
                      <TooltipProvider>
                        <Tooltip>
                          <TooltipTrigger asChild>
                            <InfoIcon
                              size={16}
                              color="#F1F1F1"
                              className="shrink-0"
                            />
                          </TooltipTrigger>
                          <TooltipContent className="bg-white border ">
                            <p className="w-[300px] text-xs text-center">
                              Errors can arise due to slow internet, switching
                              tabs while syncing, or delay in response via
                              LinkedIn
                            </p>
                          </TooltipContent>
                        </Tooltip>
                      </TooltipProvider>
                    </span>
                  </span>
                </div>

                <PostPerformanceTable
                  postData={{
                    posts: extData?.posts,
                  }}
                />
              </div>
            </div>

            {/* Demographics Table */}
            {(extData?.Demographics?.[0]?.jobTitles?.length > 0 ||
              extData?.Demographics?.[0]?.location?.length > 0 ||
              extData?.Demographics?.[0]?.seniority?.length > 0) && (
              <div className="py-6 flex flex-col gap-3 ">
                <span className="text-xl">Top demographics</span>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                  {/* Job Titles Table */}
                  {extData?.Demographics?.[0]?.jobTitles?.length > 0 && (
                    <div className="border border-[#262626] rounded-[10px]">
                      <Table className="min-w-[360px] w-full">
                        <TableHeader>
                          <TableRow className="bg-[#1e1e1e] hover:bg-[#1e1e1e] border-b border-[#262626]">
                            {/* <TableHead className="text-center">
                              S. No.
                            </TableHead> */}
                            <TableHead className="text-start">
                              Job Title
                            </TableHead>
                            <TableHead className="text-right">
                              Percentage
                            </TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {extData?.Demographics?.[0]?.jobTitles.map((job) => (
                            <TableRow
                              key={job._id}
                              className="border-b border-[#262626]"
                            >
                              {/* <TableCell className="text-center">
                                  {index + 1}
                                 </TableCell> */}
                              <TableCell className="text-start">
                                {job.value}
                              </TableCell>
                              <TableCell className="text-right">
                                {job.percentage}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  )}
                  {/* Location Table */}
                  {extData?.Demographics?.[0]?.location?.length > 0 && (
                    <div className="border border-[#262626] rounded-[10px]">
                      <Table className="min-w-[360px] w-full">
                        <TableHeader>
                          <TableRow className="bg-[#1e1e1e] hover:bg-[#1e1e1e] border-b border-[#262626]">
                            {/* <TableHead className="text-center">
                              S. No.
                            </TableHead> */}
                            <TableHead className="text-start">
                              Location
                            </TableHead>
                            <TableHead className="text-right">
                              Percentage
                            </TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {extData?.Demographics?.[0]?.location.map((loc) => (
                            <TableRow
                              key={loc._id}
                              className="border-b border-[#262626]"
                            >
                              {/* <TableCell className="text-center">
                                  {index + 1}
                                </TableCell> */}
                              <TableCell className="text-start">
                                {loc.value}
                              </TableCell>
                              <TableCell className="text-right">
                                {loc.percentage}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  )}

                  {/* Seniority Table */}
                  {extData?.Demographics?.[0]?.seniority?.length > 0 && (
                    <div className="border border-[#262626] rounded-[10px]">
                      <Table className="min-w-[360px] w-full">
                        <TableHeader>
                          <TableRow className="bg-[#1e1e1e] hover:bg-[#1e1e1e] border-b border-[#262626]">
                            {/* <TableHead className="text-center">
                              S. No.
                            </TableHead> */}
                            <TableHead className="text-start">
                              Seniority
                            </TableHead>
                            <TableHead className="text-right">
                              Percentage
                            </TableHead>
                          </TableRow>
                        </TableHeader>
                        <TableBody>
                          {extData?.Demographics?.[0]?.seniority.map((sen) => (
                            <TableRow
                              key={sen._id}
                              className="border-b border-[#262626]"
                            >
                              {/* <TableCell className="text-center">
                                  {index + 1}
                                </TableCell> */}
                              <TableCell className="text-start">
                                {sen.value}
                              </TableCell>
                              <TableCell className="text-right">
                                {sen.percentage}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </div>
      )}
      {!loading && !extData?.profile?.updatedAt && (
        <SyncLinkedinWithExt
          resync={true}
          redirectUrl={`${window.location.origin}/influencer/plugin/callback`}
        />
      )}
    </>
  );
};

const LoadingSkeleton = () => {
  return (
    <div className="bg-[#171717] grid min-h-screen w-full text-white/80 py-6">
      <div className="w-full px-[4%] md:px-[10%] overflow-hidden h-full">
        <div className="flex flex-col md:flex-row justify-between">
          <div className="flex flex-col md:flex-row gap-3 items-center py-10 md:py-4 px-4 animate-pulse">
            <div className="size-20 rounded-full bg-gray-500"></div>
            <div className="text-center md:text-start flex flex-col gap-2 items-center md:items-start">
              <h3 className="font-bold text-xl bg-gray-500 w-44 h-6 rounded-full"></h3>
              <p className="text-gray-400 text-sm bg-gray-500 w-60 h-4 rounded-full"></p>
              <span className="text-muted-foreground bg-gray-500 rounded-full w-20 h-4 "></span>
            </div>
          </div>
          <div className="flex flex-row md:justify-end  items-center animate-pulse justify-center">
            <div className="flex md:flex-row gap-2 md:items-start  items-center">
              <span className="text-white font-inter bg-gray-500 w-20 h-8 rounded-full"></span>
              <span className="text-white font-inter bg-gray-500 w-20 h-8 rounded-full"></span>
            </div>
          </div>
        </div>

        <div className="py-6 flex flex-col gap-3 animate-pulse">
          <span className="text-xl bg-gray-500 w-40 h-6 rounded-full"></span>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="border border-[#262626] rounded-[10px] bg-gray-500 w-full h-48"></div>
            <div className="border border-[#262626] rounded-[10px] bg-gray-500 w-full h-48"></div>
            <div className="border border-[#262626] rounded-[10px] bg-gray-500 w-full h-48"></div>
          </div>
        </div>

        <div className="">
          <div className="py-6 flex flex-col gap-3 animate-pulse">
            <span className="text-xl bg-gray-500 w-40 h-6 rounded-full"></span>
            <div className="border border-[#262626] rounded-[10px] bg-gray-500 w-full h-48"></div>
          </div>
        </div>
      </div>
    </div>
  );
};
